import type { FactoriesTranslations } from './types';

/**
 * Arabic translations for Factories domain
 */
export const arTranslations: FactoriesTranslations = {
  // Page/Section level
  title: 'المصانع',
  subtitle: 'إدارة مصانع الإنتاج والمنشآت الصناعية',

  // Actions
  addFactory: 'إضافة مصنع',
  editFactory: 'تعديل المصنع',
  deleteFactory: 'حذف المصنع',
  factoryDetails: 'تفاصيل المصنع',

  // Search and states
  searchPlaceholder: 'البحث عن المصانع...',
  filterByStatus: 'تصفية حسب الحالة',
  noFactories: 'لا توجد مصانع',
  noFactoriesDescription: 'لم تقم بإضافة أي مصانع بعد. أضف أول مصنع للبدء.',
  addFirst: 'أضف أول مصنع',
  totalFactories: 'إجمالي المصانع',

  // Form fields
  form: {
    factory: 'المصنع',
    selectFactory: 'اختر المصنع',
    code: 'رمز المصنع',
    codePlaceholder: 'أدخل رمز المصنع (مثال: FAC-001)',
    sapPlantCode: 'رمز مصنع SAP',
    sapPlantCodePlaceholder: 'أدخل رمز مصنع SAP (مثال: 1000)',
    nameEn: 'اسم المصنع (بالإنجليزية)',
    nameEnPlaceholder: 'أدخل اسم المصنع بالإنجليزية',
    nameAr: 'اسم المصنع (بالعربية)',
    nameArPlaceholder: 'أدخل اسم المصنع بالعربية',
    address: 'العنوان',
    addressPlaceholder: 'أدخل عنوان الشارع',
    city: 'المدينة',
    selectCity: 'اختر المدينة',
    country: 'الدولة',
    selectCountry: 'اختر الدولة',
    postalCode: 'الرمز البريدي',
    timezone: 'المنطقة الزمنية',
    coordinates: 'الإحداثيات',
    status: 'الحالة',
  },

  // Validation
  validation: {
    codeRequired: 'رمز المصنع مطلوب',
    nameRequired: 'اسم المصنع مطلوب',
    countryRequired: 'الدولة مطلوبة',
  },

  // Status
  status: {
    active: 'نشط',
    inactive: 'غير نشط',
  },

  // Messages
  messages: {
    createSuccess: 'تم إنشاء المصنع بنجاح',
    updateSuccess: 'تم تحديث المصنع بنجاح',
    deleteSuccess: 'تم حذف المصنع بنجاح',
    deleteConfirm: 'هل أنت متأكد من حذف هذا المصنع؟',
  },

  // Card display
  card: {
    noAddress: 'لا يوجد عنوان',
    noCity: 'لا توجد مدينة',
    noCountry: 'لا توجد دولة',
    locationNotSet: 'الموقع غير محدد',
    created: 'تاريخ الإنشاء',
    updated: 'تاريخ التحديث',
  },

  // Top-level convenience keys (flat versions for direct access)
  code: 'رمز المصنع',
  codePlaceholder: 'أدخل رمز المصنع (مثال: FAC-001)',
  sapPlantCode: 'رمز مصنع SAP',
  sapPlantCodePlaceholder: 'أدخل رمز مصنع SAP (مثال: 1000)',
  nameEn: 'اسم المصنع (بالإنجليزية)',
  nameEnPlaceholder: 'أدخل اسم المصنع بالإنجليزية',
  nameAr: 'اسم المصنع (بالعربية)',
  nameArPlaceholder: 'أدخل اسم المصنع بالعربية',
  address: 'العنوان',
  addressPlaceholder: 'أدخل عنوان الشارع',
  city: 'المدينة',
  selectCity: 'اختر المدينة',
  country: 'الدولة',
  selectCountry: 'اختر الدولة',
  postalCode: 'الرمز البريدي',
  timezone: 'المنطقة الزمنية',
  coordinates: 'الإحداثيات',
  statusLabel: 'الحالة',
  codeRequired: 'رمز المصنع مطلوب',
  nameRequired: 'اسم المصنع مطلوب',
  countryRequired: 'الدولة مطلوبة',
  active: 'نشط',
  inactive: 'غير نشط',
  createSuccess: 'تم إنشاء المصنع بنجاح',
  updateSuccess: 'تم تحديث المصنع بنجاح',
  deleteSuccess: 'تم حذف المصنع بنجاح',
  deleteConfirm: 'هل أنت متأكد من حذف هذا المصنع؟',
  noAddress: 'لا يوجد عنوان',
  noCity: 'لا توجد مدينة',
  noCountry: 'لا توجد دولة',
  locationNotSet: 'الموقع غير محدد',
  created: 'تاريخ الإنشاء',
  updated: 'تاريخ التحديث',
  addDescription: 'أضف منشأة تصنيع جديدة',
  editDescription: 'حدّث تفاصيل المصنع',
  basicInfo: 'المعلومات الأساسية',
  selectStatus: 'اختر الحالة',
  locationInfo: 'الموقع',
  selectLocation: 'اختر الموقع',
  noLocationOption: 'بدون موقع',
  locationHint: 'اختر موقعًا موجودًا من دفتر العناوين أو اتركه فارغًا',
  citiesServed: 'المدن المخدومة',
  citiesServedHint: 'حدد المدن التي يمكن لهذا المصنع التوصيل إليها',
  searchCities: 'ابحث عن المدن...',
  noCitiesMatch: 'لا توجد مدن تطابق البحث',
  noCitiesAvailable: 'لا توجد مدن متاحة',
  selectedCityCount: 'تم اختيار {{count}} مدينة',
  selected: 'محدد',
  loadMoreCities: 'تحميل المزيد من المدن',
  descriptionSection: 'الوصف',
  descriptionEn: 'الوصف (بالإنجليزية)',
  descriptionAr: 'الوصف (بالعربية)',
  descriptionPlaceholder: 'أدخل وصف المصنع',
  descriptionArPlaceholder: 'أدخل وصف المصنع بالعربية',
  saving: 'جارٍ الحفظ...',
  deleting: 'جارٍ الحذف...',
  close: 'إغلاق',
};
